export default __webpack_public_path__ + "static/media/IMG_2374_tn.8c8bf2ed.jpg";